'use client';

import React from 'react';
import { Box, Chip } from '@mui/material';
import PlaceIcon from '@mui/icons-material/Place';
import { usePathname } from 'next/navigation';
import { extractPageContext } from '../../utils/contextExtractor';

export default function ContextChips() {
  const pathname = usePathname();
  const { label, page } = extractPageContext(pathname || '/');

  // Don't show chip for unknown pages
  if (!page || page === 'unknown') return null;

  return (
    <Box sx={{ mb: '0.5rem' }}>
      <Chip
        icon={<PlaceIcon sx={{ fontSize: '0.8rem' }} />}
        label={label}
        size="small"
        sx={{
          bgcolor: 'rgba(71, 225, 188, 0.08)',
          color: 'var(--primary-color)',
          borderRadius: '12px',
          fontSize: '0.7rem',
          height: 24,
          '& .MuiChip-icon': { color: 'var(--primary-color)' },
        }}
      />
    </Box>
  );
}
